import Vue from 'vue'
import {
  liveStats, Topics, STATS_TYPES_INDEX, AGGREGATION_LEVELS_INDEX,
} from '@/mqtt/liveStats'
import LiveStatsApi from '@/api/live-stats'

const _state = {}

const mutations = {
  updateStats(state, statsUpdate) {
    Vue.set(state, statsUpdate.topic, statsUpdate.message)
  },
}

const actions = {
  subscribeStatsAction: async ({ commit }, payload) => {
    liveStats.subscribeStats(payload, (topic, message, statsUpdate) => {
      commit('updateStats', {
        topic,
        message,
      })
      if (payload.callback) {
        payload.callback(statsUpdate)
      }
    })
  },

  fetchStatsAction: async ({ commit }, payload) => {
    const stats = await LiveStatsApi.getStats({
      slideId: payload.id,
      version: payload.version,
    })
    if (!stats) return

    stats.perActitityStats.forEach((s) => {
      const topic = `${STATS_TYPES_INDEX[s.statsType]}/${AGGREGATION_LEVELS_INDEX[s.aggregationLevel]}/${s.activityId}/${s.activityVersion}`
      const message = s.count
      commit('updateStats', { topic, message })
    })

    stats.perAnswerValueStats.forEach((s) => {
      const topic = `${STATS_TYPES_INDEX[s.statsType]}/${AGGREGATION_LEVELS_INDEX[s.aggregationLevel]}/${s.activityId}/${s.activityVersion}/${s.questionId}/${s.answerValue}`
      const message = s.count
      commit('updateStats', { topic, message })
    })
  },

  unsubscribeStatsAction(_, payload) {
    liveStats.unsubscribeStats(payload)
  },
}

const getters = {
  answerCountPerAnswerValue(state) {
    return (activityId, questionId, version, answerValue) => {
      return Number(state[Topics.answerCountPerAnswerValueTopic(activityId, questionId, version, answerValue)])
    }
  },
  answerCountPerActivity(state) {
    return (activityId, version) => {
      return Number(state[Topics.answerCountPerActivityTopic(activityId, version)])
    }
  },
  answererCountPerQuestion(state) {
    return (activityId, questionId, version) => {
      return Number(state[Topics.answererCountPerQuestionTopic(activityId, questionId, version)])
    }
  },
  averageScorePerQuestion(state) {
    return (activityId, version, questionId) => {
      return state[Topics.averageScorePerQuestionTopic(activityId, version, questionId)]
    }
  },
  averageScorePerActivity(state) {
    return (activityId, version) => {
      return state[Topics.averageScorePerActivityTopic(activityId, version)]
    }
  },
  reactionCountPerType(state) {
    return (liveSessionId, version, reactionType) => {
      return Number(state[Topics.reactionCountPerTypeTopic(liveSessionId, version, reactionType)])
    }
  },
  correctAnswerCountPerActivity(state) {
    return (activityId, version) => {
      return Number(state[Topics.correctAnswerCountPerActivityTopic(activityId, version)] || 0)
    }
  },
  incorrectAnswerCountPerActivity(state) {
    return (activityId, version) => {
      return Number(state[Topics.incorrectAnswerCountPerActivityTopic(activityId, version)] || 0)
    }
  },
  correctAnswerCountPerAnswerValue(state) {
    return (activityId, version, questionId, answerValue) => {
      return Number(state[Topics.correctAnswerCountPerAnswerValueTopic(activityId, version, questionId, answerValue)] || 0)
    }
  },
  incorrectAnswerCountPerAnswerValue(state) {
    return (activityId, version, questionId, answerValue) => {
      return Number(state[Topics.incorrectAnswerCountPerAnswerValueTopic(activityId, version, questionId, answerValue)] || 0)
    }
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
